import { Locale } from "./transloco.http-loader";

import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";

import enUS from '@assets/i18n/en-US';
import daDK from '@assets/i18n/da-DK';
import deDE from '@assets/i18n/de-DE';
import esES from '@assets/i18n/es-ES';
import nlNL from '@assets/i18n/nl-NL';
import trTR from '@assets/i18n/tr-TR';

@Pipe({
  name: 'i18n',
})
export class I18nPipe implements PipeTransform {
  public translations: any = enUS;
  public lang: string = Locale.ENGLISH_USA;

  constructor(private translocoService: TranslocoService) {
    this.lang = this.translocoService.getActiveLang() || Locale.ENGLISH_USA;
    this.setTranslationObject();
    this.translocoService.langChanges$.subscribe((lang) => {
      this.lang = lang;
      this.setTranslationObject();
    })
  }

  public setTranslationObject(): void {
    if (this.lang === Locale.DUTCH) this.translations = nlNL;
    if (this.lang === Locale.DANISH) this.translations = daDK;
    if (this.lang === Locale.GERMAN) this.translations = deDE;
    if (this.lang === Locale.SPANISH) this.translations = esES;
    if (this.lang === Locale.TURKICH) this.translations = trTR;
    if (this.lang === Locale.ENGLISH_UK) this.translations = enUS;
    if (this.lang === Locale.ENGLISH_USA) this.translations = enUS;
  }

  public transform(key: string, ...args): string {
    let translations: string = this.translations?.[key];
    if (translations && args.length) {
      Object.keys(args[0]).forEach((paramKey: string) => translations = translations.replace(`{{ ${paramKey} }}`, args[0][paramKey]))
    }
    return translations || key;
  }
}
